export default function(o, tag){

  var rollLabel = o.util.getTranslation(o, 'roll')

  var home = function(){
    history.pushState({}, '', '/')
    o.render(o)
  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.8rem",
    })
    .append([

      o.component.button(o, 'open memory box', home),

      o.component.spacer(o),

      $('<div>')
      .css({
        display: 'inline-block',
        margin: '5px',
        color: o.colors.red,
      })
      .html(rollLabel),

    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/roll/header/header.js